import { css } from "@emotion/react";

export const containerStyle = css`
  background: url("/images/bg.png") no-repeat;
  background-color: #202020;
  position: absolute;
  width: 100%;
  height: 100%;
  overflow-y: hidden;
  overflow-x: hidden;
  background-position: right -195px bottom -145px;
  background-size: 70%;

  @media only screen and (min-height: 1080px) {
    background-position: right -204px bottom -20px;
    background-size: 71%;
  }

  @media (max-width: 768px) {
    background-position: right -126px bottom -48px;
    background-size: 150%;
  }

  @media (max-width: 414px) {
    background-position: right -132px bottom -37px;
    background-size: 290%;
  }
`;

export const cardStyle = css`
  background: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translateX(-50%) translateY(-50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);

  padding: 40px;
  width: 464px;

  @media only screen and (max-width: 414px) {
    padding: 32px 16px !important;
    width: 95%;
  }
`;
